export default "__VITE_ASSET__C_ItLW$A__"